import { IUser } from "src/app/models/IUser";

export namespace UserActions {
    export class SetUser {
        public static readonly type = '[User] Set User';
        constructor(public user: IUser) {}
    }
}